// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ProductType } from '@shared/utils/Instruments/ProductType';
import { RiskPlan } from './RiskPlan';
export class RiskPlanSettings {
    constructor() {
        // <ProductType, RiskPlanItem>
        this.cache = {};
    }
    get availableProductTypes() {
        return Object.keys(this.cache)
            .sort((a, b) => ProductType[a].localeCompare(ProductType[b]))
            .map((p) => Number(p));
    }
    get(productType) {
        return this.cache[productType] || null;
    }
    addItem(item) {
        var _a;
        if (!item)
            return null;
        if (item.ProductType) {
            RiskPlan.showProductType = true;
        }
        const cache = this.cache;
        if ((_a = cache[item.ProductType]) === null || _a === void 0 ? void 0 : _a.mergeWith) {
            cache[item.ProductType].mergeWith(item);
        }
        else {
            cache[item.ProductType] = item;
        }
    }
    mergeWith(settings) {
        if (!settings) {
            return;
        }
        const types = this.availableProductTypes;
        for (let i = 0, len = types.length; i < len; i++) {
            this.addItem(settings.get(types[i]));
        }
    }
    getCopy() {
        const copy = new RiskPlanSettings();
        const cache = this.cache;
        for (const key in cache) {
            copy.addItem(cache[key].getCopy());
        }
        return copy;
    }
    getValue(productType, literal) {
        const c = this.get(productType);
        if (!(c === null || c === void 0 ? void 0 : c.getValue)) {
            return null;
        }
        return c.getValue(literal);
    }
}
